const SlicknextCircle = ({ ...props }) => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
            <circle cx="20" cy="20" r="20" fill="currentcolor" />
            <path
                d="M16 13L22.6316 19.6316L16 26.2632"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default SlicknextCircle
